export default __webpack_public_path__ + "f0057d5a9345275afed3188183f50123.jpg";